import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { OnboardingTour } from '../onboarding/OnboardingTour';

export function AppShell(): JSX.Element {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="relative min-h-screen overflow-hidden">
      <div
        className="pointer-events-none absolute -top-48 right-[-20%] h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle_at_center,hsl(237_86%_66%/.35),transparent_65%)] blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-40 left-[-15%] h-[460px] w-[460px] rounded-full bg-[radial-gradient(circle_at_center,hsl(189_88%_68%/.3),transparent_65%)] blur-3xl"
        aria-hidden
      />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="sm:pl-72">
        <TopBar onToggleSidebar={() => setSidebarOpen((prev) => !prev)} />

        <main className="px-4 pb-12 pt-6 sm:px-8">
          <div className="mx-auto flex w-full max-w-6xl flex-col gap-6">
            <Outlet />
          </div>
        </main>
      </div>
      <OnboardingTour />
    </div>
  );
}
